import { queryOptions } from '@tanstack/react-query';

import { api } from '~/lib/api';
import { i18n } from '~/lib/i18n';

export function stagesQueryOptions(orgId: string) {
  return queryOptions({
    queryKey: ['workflow-stages', orgId] as const,
    queryFn: async () => {
      const response = await api.api.org[':orgId']['workflow-stages'].$get({
        param: { orgId }
      });
      if (!response.ok) throw new Error(i18n.t('errors.unexpected'));
      return response.json();
    }
  });
}
